import $ from 'jquery'
import 'select2'

( ->
  class SelectPicker
    init: (root) ->
      $(document).ready ->
        $root = if root then $(root) else $(document)

        $('.chosen-select').select2({
          width: '100%',
          templateResult: (data) ->
            # Return default text for placeholder or no data
            return data.text unless data.id

            html = $(data.element).data('html')
            return data.text unless html

            $(html)
          templateSelection: (data) ->
            data.text
        })

        $('.chosen-select-multiple').select2({
          width: '100%',
          multiple: true,
          templateResult: (data) ->
            # Return default text for placeholder or no data
            return data.text unless data.id

            if data.selected
              return null

            html = $(data.element).data('html')
            return data.text unless html

            $(html)
          templateSelection: (data) ->
            data.text
        })

        $('.chosen-select-multiple-with-prepopulation').select2({
          width: '100%',
          multiple: true,
          templateResult: (data) ->
            # Return default text for placeholder or no data
            return data.text unless data.id

            if data.selected
              return null

            html = $(data.element).data('html')
            return data.text unless html

            $(html)
          templateSelection: (data) ->
            data.text
        })

        option_values = $(".chosen-select-multiple-with-prepopulation option").map( (index, option) -> option.value ).get()
        $(".chosen-select-multiple-with-prepopulation").val(option_values).trigger("change")

        $('.select-with-ajax').select2({
          width: '100%'
          escapeMarkup: (markup) ->
            markup
          templateResult: (data) ->
            if data.loading
              return data.text
            if data.html
              return data.html
            data.text
          templateSelection: (data) ->
            data.text
          ajax: {
            dataType: 'json'
            cache: true
            data: (params) ->
              query = {
                search: params.term,
                page: params.page || 1
              }
              query
            processResults: (data) ->
              data
          }
        })

        $root.find('.chosen-select-with-tags').select2({
          width: '100%',
          templateResult: (data) ->
            formatState(data)
        })

    renderPills = (employeeType) ->
      label = switch employeeType
        when 'Insured' then 'Account Holder'
        when 'SME' then 'Account Contact'
        else employeeType

      """
        <span class="sq:accent-active-pill fs-xxs px-2 py-1">#{label}</span>
      """

    formatState = (state) ->
      return state.text unless state.id

      $state = $("""
        <div class="flex-column gap-2" value="#{state.id}">
          <div class="flex-row gap-5 alt-align-center">
            <span value="#{state.element.value}">#{state.text}</span>
            #{renderPills(state.element.dataset.employeeType)}
          </div>

          <span class="fs-xs">#{state.element.dataset.email}</span>
        </div>
      """)

      return $state

    hideSelected = (value) ->
      if value and not value.selected
        $('<span>' + value.text + '</span>')
      else
        null

    onSelect: (elementRef, callback) ->
      $(elementRef).on 'select2:select', callback

    onUnselect: (elementRef, callback) ->
      $(elementRef).on 'select2:unselect', callback

    onChange: (elementRef, callback) ->
      $(elementRef).on 'change', callback

    triggerChange: (elementRef) ->
      $(elementRef).trigger('change')

    refresh_select: (id) ->
      $(id).each ->
        $selectElement = $(this)
        firstOptionValue = $selectElement.find('option:first').val()
        $selectElement.val(firstOptionValue)
        $selectElement.trigger('change.select2')

    formatDataSelection = (data) ->
      data.text

    clearDatepickerFields: (elementRef) ->
      $(elementRef).each (index, ele) ->
        ele.value = ''
        datetimepicker.set_hidden_date_value(ele)

      datetimepicker.set_picker()

  window.selectpicker = new SelectPicker();
).call this
